import LoadingSpinner from "../../LoadingSpinner";
import React, {forwardRef, useEffect, useImperativeHandle, useState} from "react";
import FileUploader from "../../FileUploader";
import Dropdown from "../../input/Dropdown";
import {getDropdownData} from "../../../api/keyvalue";
import {FORMS, MODULES} from "../../../const";
import {useSelector} from "react-redux";

const FORM = FORMS.CHARGE_CREATION.CHARGE_BULK_UPLOAD.form;
const DeductionBulkUpload = forwardRef(
    ({ isLoading, onUpload}, ref) => {

        const [files, setFiles] = useState([]);
        const [currentErrors, setCurrentErrors] = useState({});
        const [extensionOptions, setExtensionOptions] = useState([]);
        const [isExtensionLoading, setIsExtensionLoading] = useState(false);
        const [currentFileExtension, setCurrentFileExtension] = useState(null);
        const [errors, setErrors] = useState({});
        const [documentTypeOptions, setDocumentTypeOptions] = useState([]);
        const user = useSelector((state) => state.user);

        const [documentData, setDocumentData] = useState({
            docCategory: 2,
            fileType: 5,
            file: null,
            userName:user.username,
        });

        useEffect(() => {
            (async () => {
                const docTypeData = await getDropdownData("doc_type");
                setDocumentTypeOptions(docTypeData);

                const extensionData = await getDropdownData(
                    "file_type",
                    "2"
                );
                const extensionType = extensionData.filter(item => [1, 5].includes(item.key));
                setExtensionOptions(extensionType);

            })();
        }, []);


        const addCurrentExtension = async(e, data) => {
            setDocumentData((prevState) => ({
                ...prevState,
                fileType: data.value,
            }));
        };

        useEffect(() => {
            (async () => {
                setIsExtensionLoading(true);
                const extensionData = await getDropdownData("file_type", "2", [
                    "keyValue2",
                ]);

                const extension = extensionData?.find(
                    (ext) => ext.key === documentData.fileType
                );

                setCurrentFileExtension(extension ? extension.keyValue2 : null);
                setIsExtensionLoading(false);
            })();
        }, [documentData.fileType]);

        useEffect(() => {

            setDocumentData((prevState) => ({
                ...prevState,
                file: files,
            }));
        }, [files]);

        useImperativeHandle(ref, () => ({
            getData: () => documentData,
            reset: () => {
                setFiles([]);
                setErrors({});
            },
        }));

        return (
            <>
                {isLoading ? (
                    <LoadingSpinner />
                ) : (
                    <form
                        className="ui form"
                        style={{ overflowY: "auto", height: "75vh" }}
                    >
                        <div className="ui form segment">
                            <h4 className="ui dividing header">Upload Document</h4>
                            <div className="two fields">
                                <Dropdown
                                    readOnly={true}
                                    label="Document Category"
                                    placeholder="Document Type"
                                    options={documentTypeOptions}
                                    value={documentData.docCategory}
                                    style={{height: "5px"}}

                                />

                                <Dropdown
                                    label="Extensions"
                                    required={true}
                                    placeholder={"Extensions"}
                                    options={extensionOptions}
                                    value={documentData.fileType}
                                    style={{height: "5px"}}
                                    onChange={
                                        addCurrentExtension
                                    }
                                    clearable={false}
                                    authenticated={false}
                                    module={MODULES.Finance}
                                    form={FORM}
                                />
                            </div>

                            <div className={`field ${errors.file ? "error" : ""}`}>
                                <label>
                                    <span style={{color: "#9f3a38"}}>*</span> Select File
                                </label>
                                <FileUploader
                                    files={files}
                                    setFiles={setFiles}
                                    maxFiles={1}
                                    errors={currentErrors}
                                    acceptedMimeTypes={[currentFileExtension]}
                                    key={currentFileExtension}
                                    documentData={documentData}
                                    extensionOptions={extensionOptions}
                                    disabled={

                                        currentFileExtension === null ||
                                        isExtensionLoading
                                            ? true
                                            : false
                                    }
                                />
                                <small style={{color: "#9f3a38"}}>{errors.file || ""}</small>
                            </div>
                        </div>
                    </form>
                )}
            </>
        );


    }
);

export default DeductionBulkUpload;
